import { clamp } from '@styles/utils/conversion.style'
import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'
import {
  getCustomTextStyle,
  textStylesConfig,
} from '@styles/vars/textStyles.style'
import styled from 'styled-components'

export const HeroMain = styled.section`
  color: ${colors.charcoal};
  background-color: ${colors.mist};

  h1 {
    ${getCustomTextStyle(
      textStylesConfig.heading2Serif,
      textStylesConfig.heading2Serif
    )}
  }
`

export const HeroImage = styled.div`
  ${clamp('margin-bottom', 20, 40)};
  aspect-ratio: 16/9;
  max-height: 310px;
  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }
`
export const HeroText = styled.div`
  margin-left: auto;
  ${getCustomTextStyle(
    textStylesConfig.heading4Sans,
    textStylesConfig.body
  )}
  text-align: right;
  max-width: 550px;
`